export default __webpack_public_path__ + "dae09a1f905fc0c70faacdc38fd3a81e.png";